"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsClient = require("@statsig/js-client");

var _reactBindings = require("@statsig/react-bindings");

var _configment = _interopRequireDefault(require("@adc/configment"));

var _analytics = _interopRequireDefault(require("@adc/analytics"));

var _lodash = require("lodash");

var _statsigConfig = require("./constants/statsig-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
var track = _analytics["default"].track;
/**
 * trackExperiment
 * @description On the event of a statsig experiment being evaluated, the method
 * pushes the experiment id and variation id to the GTM data layer.
 */

var trackExperiment = function trackExperiment(entity) {
  if (entity.name === _statsigConfig.STATSIG_EVENTS.EXPERIMENT_EVALUATION) {
    var _entity$experiment, _entity$experiment2, _entity$experiment3;

    track(_statsigConfig.STATSIG_EVENTS.EXPERIMENT_EVALUATION, {
      experiment_id: (_entity$experiment = entity.experiment) === null || _entity$experiment === void 0 ? void 0 : _entity$experiment.name,
      variation_id: ((_entity$experiment2 = entity.experiment) === null || _entity$experiment2 === void 0 ? void 0 : _entity$experiment2.groupName) || ((_entity$experiment3 = entity.experiment) === null || _entity$experiment3 === void 0 ? void 0 : _entity$experiment3.__evaluation.group)
    });
  }
};
/**
 * initialize
 * @description initializes Client SDK by passing the client sdk key
 * and the statsig user object for feature gate targeting and experimentation
 * grouping purposes.
 *
 * */


var initialize = function initialize(options) {
  var sdkClient = new _jsClient.StatsigClient(_configment["default"].get('STATSIG_API_KEY', ''), options.user);
  sdkClient.dataAdapter.setData(options.values);
  sdkClient.on(_statsigConfig.STATSIG_EVENTS.EXPERIMENT_EVALUATION, trackExperiment);
  sdkClient.initializeSync();
  return sdkClient;
};
/**
 * useFeatureFlag
 * @description custom react hook to get the value of a statsig client feature gate,
 * config or experiment and includes an exposure event to be logged. The hook is intended
 * to be called within a react component that subscribes to the statsig react context
 * ToDo: Remove after useExperimentFlag has replaced all calls to useFeatureFlag
 * */


var useFeatureFlag = function useFeatureFlag() {
  var featureFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    type: '',
    name: ''
  };

  var _useContext = (0, _react.useContext)(_reactBindings.StatsigContext),
      client = _useContext.client;

  var type = featureFlag.type,
      name = featureFlag.name;
  return (0, _react.useMemo)(function () {
    /*
     * By default, the flag object will be assigned value property. In the event
     * the type is not a feature gate, flag object will have a get method. The get method
     * is the pattern for the statsig client to get the value of a config or experiment.
     * If an empty object or the statsig feature gate, config or experiment doesn't
     * exist, then it will consistently return a default value.
     * */
    var flag = Object.assign({}, type === _statsigConfig.STATSIG_TYPES.FEATURE_GATE ? {
      value: false
    } : {
      value: {}
    }, type !== _statsigConfig.STATSIG_TYPES.FEATURE_GATE && {
      get: function get(param) {
        var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return this.value[param] ? this.value[param] : fallback;
      }
    });

    switch (type) {
      case _statsigConfig.STATSIG_TYPES.FEATURE_GATE:
        flag = client.getFeatureGate(name);
        break;

      case _statsigConfig.STATSIG_TYPES.CONFIG:
        flag = client.getDynamicConfig(name);
        break;

      case _statsigConfig.STATSIG_TYPES.EXPERIMENT:
        flag = client.getExperiment(name);
        break;
    }

    return flag;
  }, [client, name, type]);
};
/**
 * useExperimentFlag
 * @description custom react hook to get the value of a statsig client feature gate,
 * config or experiment and includes an exposure event to be logged. The hook is intended
 * to be called within a react component that subscribes to the statsig react context
 * */


var useExperimentFlag = function useExperimentFlag() {
  var experimentFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    type: '',
    name: ''
  };

  var _useContext2 = (0, _react.useContext)(_reactBindings.StatsigContext),
      client = _useContext2.client;

  var type = experimentFlag.type,
      name = experimentFlag.name;
  return (0, _react.useMemo)(function () {
    /*
     * By default, the flag object will be assigned value property. In the event
     * the type is not a feature gate, flag object will have a get method. The get method
     * is the pattern for the statsig client to get the value of a config or experiment.
     * If an empty object or the statsig feature gate, config or experiment doesn't
     * exist, then it will consistently return a default value.
     * */
    var flag = Object.assign({}, type === _statsigConfig.STATSIG_TYPES.FEATURE_GATE ? {
      value: false
    } : {
      value: {}
    }, type !== _statsigConfig.STATSIG_TYPES.FEATURE_GATE && {
      get: function get(param) {
        var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return this.value[param] ? this.value[param] : fallback;
      }
    });

    switch (type) {
      case _statsigConfig.STATSIG_TYPES.FEATURE_GATE:
        flag = client.getFeatureGate(name);
        break;

      case _statsigConfig.STATSIG_TYPES.CONFIG:
        flag = client.getDynamicConfig(name);
        break;

      case _statsigConfig.STATSIG_TYPES.EXPERIMENT:
        flag = client.getExperiment(name);
        break;
    }

    return flag;
  }, [client, name, type]);
};
/**
 * useExperiment
 * @description custom react hook to get the value of a statsig client experiment and
 * includes an exposure event to be logged. The hook is intended to be called within a
 * react component that subscribes to the statsig react context
 * */


var useExperiment = function useExperiment(featureFlag) {
  var _useContext3 = (0, _react.useContext)(_reactBindings.StatsigContext),
      client = _useContext3.client;

  var name = featureFlag.name;
  return (0, _react.useMemo)(function () {
    return client.getExperiment(name);
  }, [client, name]);
};
/**
 * For use with class components
 */


var withExperimentsContext = function withExperimentsContext(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_reactBindings.StatsigContext.Consumer, null, function () {
      return /*#__PURE__*/_react["default"].createElement(Component, props);
    });
  };
};
/**
 * Helper function to get experimentFlags property
 */


var getExperimentFlags = function getExperimentFlags() {
  var experiments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (experiments === null || experiments === void 0 ? void 0 : experiments.experimentFlags) || {};
};
/**
 *
 * ExperimentFeatureManagementProvider
 * @description react context provider that initializes the Statsig client SDK
 * */


var ExperimentFeatureManagementProvider = function ExperimentFeatureManagementProvider(_ref) {
  var user = _ref.user,
      values = _ref.values,
      children = _ref.children;

  if ((0, _lodash.isEmpty)(values) && (0, _lodash.isEmpty)(user)) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  } else {
    var client = (0, _react.useMemo)(function () {
      return initialize({
        user: user,
        values: values
      });
    }, [user, values]);
    return /*#__PURE__*/_react["default"].createElement(_reactBindings.StatsigProvider, {
      client: client
    }, children);
  }
};

ExperimentFeatureManagementProvider.propTypes = {
  user: _propTypes["default"].object,
  values: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
module.exports = {
  initialize: initialize,
  hooks: {
    useExperiment: useExperiment,
    useFeatureFlag: useFeatureFlag,
    useExperimentFlag: useExperimentFlag
  },
  withExperimentsContext: withExperimentsContext,
  ExperimentFeatureManagementProvider: ExperimentFeatureManagementProvider,
  getExperimentFlags: getExperimentFlags
};
